<template>
  <div>
    <div style="display: flex; gap: 0.5em; margin-bottom: 1em">
      <div v-for="(item, i) in breadcrumb" :key="i">
        {{ item }} <span v-if="i < breadcrumb.length - 1">/</span>
      </div>
    </div>
    <div class="m-card">
      <div style="display: flex">
        <div style="padding: 1em; display: flex; gap: 1em">
          <div>
            <img
              src="@/assets/images/oilandgas1.jpg"
              alt=""
              width="250"
              style="border-radius: 1em"
            />
          </div>
        </div>
        <div style="width: 100%">
          <div style="text-align: end">
            <b-button variant="outline-light">
              <div style="display: flex; align-items: center; gap: 0.5em">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100; color: #565656"
                >
                  edit_note
                </span>
              </div>
            </b-button>
            <b-button variant="outline-light">
              <div style="display: flex; align-items: center; gap: 0.5em">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100; color: #565656"
                >
                  qr_code_2
                </span>
              </div>
            </b-button>
            <b-button variant="outline-light">
              <div style="display: flex; align-items: center; gap: 0.5em">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100; color: #32c040"
                >
                  settings
                </span>
              </div>
            </b-button>
          </div>
          <div style="padding-left: 1em">
            <div v-for="(item, i) in info" :key="i" class="mb-3">
              {{ item.text }} : {{ item.value }}
            </div>
          </div>
        </div>
      </div>
      <!-- tabs -->
      <div>
        <b-tabs content-class="mt-3" nav-class="nav-tab">
          <b-tab >
            <template #title>
              <div class="label-tabs">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100"
                >
                  dns
                </span>
                General
              </div>
            </template>
            <InfoTabGeneral />
          </b-tab>
          <b-tab active>
            <template #title>
              <div class="label-tabs">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100"
                >
                  workspaces
                </span>
                Asset
              </div>
            </template>
            <InfoTabAsset></InfoTabAsset>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="label-tabs">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100"
                >
                  format_list_bulleted
                </span>
                Activity Log
              </div>
            </template>
            <p>I'm a disabled tab!</p>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="label-tabs">
                <span
                  class="material-icons"
                  style="font-size: 16px; font-weight: 100"
                >
                  warning
                </span>
                Alert
              </div>
            </template>
            <p>I'm a disabled tab!</p>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import InfoTabAsset from "./components/InfoTabAsset.vue";
import InfoTabGeneral from "./components/InfoTabGeneral.vue";

export default {
  components: {
    InfoTabGeneral,
    InfoTabAsset,
  },
  data() {
    return {
      breadcrumb: ["building a", "floor 1", "room 1"],
      info: [
        { text: "Name", value: "building a / floor 1 / room 1" },
        { text: "Priority Level", value: "Low Priority" },
        { text: "Environment Status", value: "good" },
        { text: "Total asset", value: 23 },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.label-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.3em;
}
</style>

<style lang="scss">
.nav-tab {
  justify-content: flex-start !important;
  li {
    width: max-content !important;
    flex: none !important;
  }
}
</style>